<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(3)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(3)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg" title="Specificatie fiscale oudedagsreserve">
  <snelstart-ui-dialog-header-content>
    Onderstaand de specificatie van de waarde van de fiscale oudedagsreserve per einde van het boekjaar.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
      <form (change)="saveForm()" [formGroup]="formGroup">
        <snelstart-ui-number-form-control label="Reservering openingsbalans"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="waardeOpening"
                                          id="bedrag-' + i"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
        <snelstart-ui-number-form-control label="Dotaties"
                                          [showAllDecimals]="false"
                                          [maxValue]="((incomeTaxEntity$ | async)?.year! > 2023) ? 0 : 10000"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="dotatieFOR"
                                          [disabledControl] = true
                                          id="bedrag-' + i"
                                          prefix="€"
                                          placeholder="n.v.t."
        >
        </snelstart-ui-number-form-control>
        <snelstart-ui-number-form-control label="Berekende vrijval"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
                                          [calculate]="totaalVrijval"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="vrijvalFOR"
                                          id="bedrag-' + i"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
        <snelstart-ui-number-form-control label="Reservering slotbalans"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="waardeSlot"
                                          id="bedrag-' + i"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button [disabled]=formGroup.invalid icon="check" id="save" type="primary" (click)="saveForm()">
          Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
